import { motion, useReducedMotion } from "framer-motion";
import { MapPin } from "lucide-react";

const CITIES = [
    { name: "Innsbruck", note: "Stadtgebiet & Umland" },
    { name: "Hall in Tirol", note: "inkl. Mils, Absam" },
    { name: "Telfs", note: "inkl. Pfaffenhofen" },
    { name: "Wattens", note: "inkl. Volders" },
    { name: "Schwaz", note: "inkl. Vomp, Stans" },
    { name: "Wörgl", note: "inkl. Kundl" },
    { name: "Kufstein", note: "auf Anfrage" },
    { name: "Seefeld", note: "auf Anfrage" },
    { name: "Imst", note: "auf Anfrage" },
];

export default function ServiceArea() {
    const reduce = useReducedMotion();
    return (
        <section
            id="einsatzgebiet"
            data-testid="service-area-section"
            className="relative py-20 sm:py-24 lg:py-28 border-t border-white/[0.06]"
        >
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
                    <div className="lg:col-span-5">
                        <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#7BD3FF]">
                            Einsatzgebiet
                        </p>
                        <h2 className="mt-3 font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-white">
                            Reinigung in <span className="text-chrome">Innsbruck</span> und ganz Tirol.
                        </h2>
                        <p className="mt-4 text-[#C9D3E1] leading-relaxed">
                            Alpen Reinigung ist Ihre <strong className="text-white">Reinigungsfirma in Innsbruck</strong>{" "}
                            und im gesamten Tiroler Inntal. Vom Treppenhaus in einer
                            Wohnanlage bis zur Glasfassade eines Bürogebäudes – wir
                            bringen die Erfahrung und das Equipment, um Ihr Objekt
                            sichtbar besser zu machen.
                        </p>
                        <p className="mt-3 text-[#C9D3E1] leading-relaxed">
                            Häufig betreute Regionen: <strong className="text-white">Innsbruck Stadt, Innsbruck-Land, Hall in Tirol, Telfs, Wattens, Schwaz, Wörgl, Kufstein und Seefeld.</strong>{" "}
                            Auch Aufträge im erweiterten Tiroler Raum sind auf Anfrage möglich.
                        </p>
                    </div>
                    <div className="lg:col-span-7">
                        <ul className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                            {CITIES.map((c, i) => (
                                <motion.li
                                    key={c.name}
                                    initial={reduce ? false : { opacity: 0, y: 10 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true, margin: "-40px" }}
                                    transition={{ duration: 0.35, delay: i * 0.03 }}
                                    className="rounded-xl border border-white/[0.10] bg-[rgba(18,27,42,0.55)] backdrop-blur-md p-4 hover:border-[rgba(123,211,255,0.35)] transition-colors"
                                >
                                    <div className="flex items-center gap-2 text-white font-medium">
                                        <MapPin className="h-4 w-4 text-[#7BD3FF]" />
                                        {c.name}
                                    </div>
                                    <p className="mt-1 text-xs text-[#8FA0B8]">{c.note}</p>
                                </motion.li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}
